import 'react';
import { Box, Typography } from '@mui/material';

interface TaxHeaderProps {
    companyName: string;
    fileNo: string;
    yearOfAssessment: string | null;
}

function formatFileNo(value: string): string {
    const trimmed = (value || '').trim();
    if (!trimmed) {
        return '';
    }

    return trimmed.includes('/') ? trimmed.substring(0, trimmed.indexOf('-')) : trimmed;
}

export function TaxHeader({
    companyName,
    fileNo,
    yearOfAssessment,
}: TaxHeaderProps) {
    const displayFileNo = formatFileNo(fileNo);

    return (
        <Box sx={{ mb: 3, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                {companyName}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
                {displayFileNo}
            </Typography>
            <Typography variant="body1">
                {yearOfAssessment || 'N/A'}
            </Typography>
        </Box>
    );
}
